var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.47065 0.46967C8.76354 0.176777 9.23841 0.176777 9.53131 0.46967L15.5313 6.46967C15.672 6.61032 15.751 6.80109 15.751 7C15.751 7.19891 15.672 7.38968 15.5313 7.53033L9.53131 13.5303C9.23841 13.8232 8.76354 13.8232 8.47065 13.5303C8.17775 13.2374 8.17775 12.7626 8.47065 12.4697L13.1903 7.75H1.00098C0.586763 7.75 0.250977 7.41421 0.250977 7C0.250977 6.58579 0.586763 6.25 1.00098 6.25H13.1903L8.47065 1.53033C8.17775 1.23744 8.17775 0.762563 8.47065 0.46967Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
